var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaginationNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.7 14l-.7-.6L5.7 7 0 .7.7 0 7 7z"
  })));
}

export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' x='0' y='0' viewBox='0 0 7 14' xml:space='preserve'%3e %3cpolygon points='0.7 14 0 13.4 5.7 7 0 0.7 0.7 0 7 7'%3e%3c/polygon%3e %3c/svg%3e";
export { SvgPaginationNext as ReactComponent };